<template>
    <div>
        <h3 class="title">No tiene permisos para realizar esta operación</h3>
    </div>
</template>

<script>
    export default {
        name: "Forbidden"
    }
</script>

<style scoped>

</style>